import { type OpenFormAsync } from './OpenFormAsync.js';

export const OpenFormFrame = (_: typeof OpenFormAsync) => {
  class Origin {
    static #targetOrigin: string | undefined;

    static {
      if (typeof self !== 'undefined') {
        try {
          const targetOrigin = new URLSearchParams(self.location.search).get('targetOrigin');
          this.#targetOrigin = targetOrigin ? decodeURIComponent(targetOrigin) : self.origin;
        } catch {
          this.#targetOrigin = self.origin;
        }
      }
    }

    static postMessage<T>(message: T, options = { targetOrigin: Origin.#targetOrigin }) {
      for (const frame of this.#frames(this.#top())) {
        frame.postMessage(message, options);
      }
    }

    static #frames(target: Window, list = [target]): Set<Window> {
      for (let i = 0; i < target.frames.length; i++) {
        list.push(...this.#frames(target.frames[i]));
      }
      return new Set(list);
    }

    static #top(target = self.top ?? self.parent): Window {
      while (target.self !== target.parent) {
        target = target.parent;
      }
      return target;
    }
  }

  return {
    postMessage<T>(message: T) {
      Origin.postMessage(message);
    },
    postMessageAcknowledge<T>(target: T) {
      Origin.postMessage({ name: 'OpenFormCanvasEvent', action: 'acknowledgement', target });
    },
    postMessageRedirectToAccount() {
      Origin.postMessage({ name: 'OpenFormCanvasEvent', action: 'redirectToAccount' });
    },
    postMessageOpenLink<T>(target: T) {
      Origin.postMessage({ name: 'OpenFormCanvasEvent', action: 'open', url: target });
    },
  };
};
